import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppProviders } from "./AppProviders";
import { config } from "./config";
import { ExternalIdAuthProvider } from "./auth/ExternalIdAuthProvider";
import { MockAuthProvider } from "./auth/MockAuthProvider";
import "./styles.css";

const AuthProvider = config.authMode === "mock" ? MockAuthProvider : ExternalIdAuthProvider;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <AppProviders>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppProviders>
    </AuthProvider>
  </StrictMode>,
);
